import { render, staticRenderFns } from "./nutritionList.vue?vue&type=template&id=09882af4&scoped=true&"
import script from "./nutritionList.vue?vue&type=script&lang=js&"
export * from "./nutritionList.vue?vue&type=script&lang=js&"
import style0 from "./nutritionList.vue?vue&type=style&index=0&id=09882af4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09882af4",
  null
  
)

export default component.exports